export function getDateLabel(date: string): Date {
  const dateValues = date.split('/');
  return new Date(Number(dateValues[0]), Number(dateValues[1]) - 1);
}

export function getGreaterDate(
  dates: (string | Date | null | undefined)[],
  whichOne: number,
) {
  const newDates = dates
    .filter(
      (x: string | Date | null | undefined) => x !== null && x !== undefined,
    )
    .map(y => {
      let newDate;
      if (typeof y === 'string') {
        newDate = new Date(Date.parse(y));
      } else {
        newDate = y;
      }
      return newDate;
    })
    .sort((a: any, b: any) => (a > b ? -1 : a < b ? 1 : 0));
  const idx = whichOne === 0 ? 0 : newDates.length - 1;
  return newDates[idx];
}
